<template>
	<div>
		<div class="ks-videoeditor-inspector-title">{{ title }}</div>
		<div class="ks-videoeditor-inline">
			<k-btn size="s" :color="value.type == 'cut' ? 'primary' : ''" @click="change({type: 'cut'})">Cut</k-btn>
			<k-btn size="s" :color="value.type == 'fade' ? 'primary' : ''" @click="change({type: 'fade'})">Fade</k-btn>
		</div>
		<k-text-field v-if="value.type == 'fade'" label="Fade duration (s)" type="number" :value="value.duration" @input="change_duration"></k-text-field>
		<slot></slot>
	</div>
</template>

<script>
import {clamp_fade} from './utils.js'

// Cut/fade chooser; v-model is the {type, duration} transition. The default slot goes below the fields.
export default {
	props: {
		title: String,
		value: Object
	},
	methods: {
		change (patch) {
			this.$emit("input", Object.assign({}, this.value, patch));
		},
		change_duration (value) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.change({duration: clamp_fade(v)});
		}
	}
}
</script>
